module.exports = __webpack_public_path__ + "img/Sneak.3d21abf1.png";